import { DataGrid, SelectBox } from "devextreme-react";
import React, { useCallback, useMemo } from "react";
import { getPropsDataGrid, getPropsDateEdit, getPropsDataGridEditing, getPropsDataGridPopup } from "../../../utils/default-props";
import { Column, Editing, FormItem, Lookup, Popup } from "devextreme-react/data-grid";
import { useDataSource } from "../../../contexts/dataSource";
import { useAuth } from "../../../contexts/auth";
import { getDataGridCustomToolbar } from "../../../components/default-components/data-grid-custom-toolbar";
import { useLookupGroup } from "../../../contexts/lookup-group-context";
import { useState } from "react";
import { useEffect } from "react";
import { lookupGroups } from "../../../utils/lookup-groups.ts";

function OverTime(props) {

  const { employeeId } = props
  const { dataSourceHR } = useDataSource()
  const { user, activeLanguage } = useAuth()
  const { getLookupData } = useLookupGroup()

  const [policyTypeList, setPolicyTypeList] = useState()

  const dataSource = useMemo(() => dataSourceHR({
          loadUrl: `/api/EmployeeOvertime/GetListByEmployeeId?EmployeeId=${employeeId}`,
      }), [employeeId, dataSourceHR])

   

  useEffect(() => {
  if (!dataSource) return;

  dataSource.load().then(data => {
    console.log("Yüklenen veriler:", data);
  }).catch(err => {
    console.error("Veri yüklenirken hata:", err);
  });
}, [dataSource]);

  const handleInitNewRow = useCallback((e) => {
    e.data.employeeId = employeeId
    e.data.active = true
  }, [employeeId])

  useEffect(() => {
    getLookupData(lookupGroups.policyType).then(response => {
      setPolicyTypeList(response)
    })
  }, [activeLanguage])


  return (
    <React.Fragment>
      <DataGrid
        {...getPropsDataGrid}
        dataSource={dataSource}
        onInitNewRow={handleInitNewRow}
      >
        <Editing {...getPropsDataGridEditing}>
          <Popup {...getPropsDataGridPopup} title="Sigorta Bilgisi" />
        </Editing>

        {getDataGridCustomToolbar("Fazla Mesai Bilgileri")}
        <Column dataField="reason"
          caption="Fazla Mesai Nedeni"
        />
        <Column dataField="location"
          caption="Fazla Mesai Yeri"
        />
        <Column dataField="approvalStatus"
          caption="Onaylanma Durumu"
        />
        <Column dataField="approvalDate"
          caption="Onaylanma Tarihi"
        />
        <Column dataField="requestDate"
          caption="İstek Tarihi"
        />
        <Column dataField="startDate"
          caption="Başlangıç Tarihi"
          {...getPropsDateEdit}
        />
        <Column dataField="endDate" caption="Bitiş Tarihi"
          {...getPropsDateEdit}
        />
        <Column dataField="plug" caption="Fiş" />
      </DataGrid>
    </React.Fragment>
  )
}

export default OverTime